import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DialogService} from "../../../../../../services/core/dialog.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {BackendApiService} from "../../../../../../services/backend-api.service";
import {
  CreateEditVendorComponent
} from "../../../../../inventory/vendor/create-edit-vendor/create-edit-vendor.component";
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {ProductDataService} from "../../../../../inventory/product/product.data.service";
import {MeasurementUnitDataService} from "../../../../../inventory/measurement-unit/measurement-unit.data.service";
import {ScopeDataService} from "../../../../../setting/scope/scope.data.service";
import {
  AddManufacturerComponent
} from "../../../../../inventory/product/product-create/add-manufacturer/add-manufacturer.component";
import {
  AddUnitOfMeasurementComponent
} from "../../../../../inventory/product/product-create/add-unit-of-measurement/add-unit-of-measurement.component";
import {ToasterService} from "../../../../../../services/core/toaster.service";
import {HelperService} from "../../../../../../services/helper.service";
import {VendorDataService} from "../../../../../inventory/vendor/vendor.data.service";
import {CurrencyMaskOptions} from "../../../../../shared/shared.constants";
import {QuickVendorComponent} from "./quick-vendor/quick-vendor.component";

@Component({
    selector: 'app-create-proposal-scope-product',
    templateUrl: './create-proposal-scope-product.component.html',
    styleUrls: ['./create-proposal-scope-product.component.scss'],
    standalone: false
})
export class CreateProposalScopeProductComponent implements OnInit {
  vendors:any=[];
  public productTypes : any = [];
  public manufacturers: any = [];
  public measurementUnits: any = [];
  public scopes: any=  [];
  scopeObject:any =[];
  isVendor: boolean = false;
  public productDefaultMarkup: any = '00';

  public proposalScopeProductForm: UntypedFormGroup = new UntypedFormGroup({
    vendor: new UntypedFormControl(null,[Validators.required]),
    // item: new UntypedFormControl(null,),
    category: new UntypedFormControl(1,[Validators.required]),
    productUrl: new UntypedFormControl(null,[Validators.pattern('(https?://)?([\\da-zA-Z.-]+)\\.([a-zA-Z.]{2,6})[/\\w .-]*/?')]),
    unitPrice: new UntypedFormControl(null,[Validators.required]),
    measurement:new UntypedFormControl(7,[Validators.required]),
    manufacturer:new UntypedFormControl(null,[Validators.required]),
    scopes:new UntypedFormControl([1],[Validators.required]),
    name:new UntypedFormControl(null,[Validators.required]),
    profit_markup: new UntypedFormControl(null,[Validators.required]),
    // qtyInStock: new UntypedFormControl(null,[Validators.required]),
    productStatus: new UntypedFormControl(1),
    vendorMultiplier: new UntypedFormControl(false),
    description: new UntypedFormControl(null),
    isManufacturerPrefixUse: new UntypedFormControl(false),
    is_vendor: new UntypedFormControl(false),
  })

  public productName: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null, [Validators.required]),
  })
  public productDetail: UntypedFormGroup = new UntypedFormGroup({
    is_manufacturer: new UntypedFormControl(false),
    vendor_prefix: new UntypedFormControl(null, [Validators.required]),
    manufacturer: new UntypedFormControl(null, [Validators.required]),
  })

  public productPrice: UntypedFormGroup = new UntypedFormGroup({
    unit_price: new UntypedFormControl(null, [Validators.required]),
    markup: new UntypedFormControl(null, [Validators.required]),
  })
  public description: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl(null),
  })
  @ViewChild('stepper') stepper: any;
  public currencyMaskOptions = CurrencyMaskOptions;

  constructor(
    public dialogService: DialogService,
    public dialogRef: MatDialogRef<CreateProposalScopeProductComponent>,
    public backendApiService:BackendApiService,
    public dialog: NgDialogAnimationService,
    public productDataService: ProductDataService,
    public  measurementUnitDataService:MeasurementUnitDataService,
    public scopeDataService: ScopeDataService,
    public toasterService: ToasterService,
    public helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public vendorDataService: VendorDataService,
  ) { }


  ngOnInit(): void {
    // this.getVendors();
    this.initDropDownData();
    this.getProductDefaultMarkup();
     console.log(this.data);
    this.proposalScopeProductForm.get('name')?.setValue(this.data?.name);
    this.proposalScopeProductForm.get('scopes')?.setValue([{id: this.data?.scope_id}]);
    this.proposalScopeProductForm.get('profit_markup')?.setValue(this.productDefaultMarkup);
  }

  getFormData = () => {
    const formValue = this.proposalScopeProductForm.value

    return {
      title:formValue.name,
      vendors: formValue.vendor?.id,
      scopes:formValue.scopes.map((res:any)=>res.id),
      measurement_unit_id:formValue.measurement,
      // item: formValue.item,
      manufacturer:formValue.manufacturer.id,
      type: formValue.category,
      // url: formValue.productUrl,
      unit_price: formValue.unitPrice,
      mark_up: formValue.profit_markup,
      // qtyInStock: formValue.qtyInStock,
      productStatus: formValue.productStatus,
      is_vendor_multiplier_enable: formValue.vendorMultiplier ? 1 : 0,
      description: formValue.description,
      is_manufacturer_prefix_use: formValue.isManufacturerPrefixUse ? 1 : 0,
      manufacturer_prefix : formValue.isManufacturerPrefixUse ? formValue.manufacturer?.prefix : '',
    }
  }
  createVendor(): void {
    const dialogRef = this.dialog.open(QuickVendorComponent, {
      width: '500px',
      maxHeight: '80vh',
      panelClass: 'quick-vendor-dialog-container',
    });
    dialogRef?.afterClosed()?.subscribe((result: any) => {
      if(result){
        console.log('result',result);
        const vendor = {id: result.data?.data?.id, name: result?.data?.data?.name};
        this.vendors.push(vendor);
        this.proposalScopeProductForm.get('vendor')?.setValue(vendor);
        this.updateDropdownItems();

        // this.proposalScopeProductForm.get('vendor')?.setValue({id:result?.data?.data?.data?.id, name:result?.data?.data?.data?.name});
      }

    });
  }
  updateDropdownItems() {
    this.vendors = [...this.vendors];
  }
  onAddManufacturer(event: any): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(AddManufacturerComponent, {
      width: '500px',
      maxWidth: '500px',
      maxHeight: '80vh',
      panelClass: 'add-manufacturer-dialog-container',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        console.log("reutn",result.data?.data);
        this.initManufacturers();
        this.proposalScopeProductForm.get('manufacturer')?.setValue(result?.data?.data);
      }
    });
  }
  onAddUnitOfMeasurement(event: any): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(AddUnitOfMeasurementComponent, {
      width: '500px',
      height: '320px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.initDropDownData();
        this.proposalScopeProductForm.get('measurement')?.setValue({id: result.data.data?.id ,name:result.data.data?.name});
      }
    });
  }
  getVendors = () =>{
    this.backendApiService.postApi('vendors','')
      .subscribe((result:any) => {
        this.vendors = result.data;
      })
  }
  initDropDownData(){
    // this.serviceService.getScopes();
    this.productDataService.getTypes()
      .subscribe((response: any) => {
        this.productTypes = response.data;
      });
    this.initManufacturers();
    this.initUnitOfMeasurement();
    this.scopesList();
  }
  initManufacturers(){
    this.productDataService.getManufacturers()
      .subscribe((response: any) => {
        this.manufacturers = response.data;
      });
  }
  initUnitOfMeasurement(){
    this.measurementUnitDataService.list()
      .subscribe((response: any) => {
        this.measurementUnits = response.data;
      });
  }
  scopesList(){
    this.scopeDataService.userSelectedScopesList()
      .subscribe((response: any) => {
        this.scopes = response.data;
      });
  }
  save = () => {
    if(this.proposalScopeProductForm.invalid){
      this.touchFormControls();
      this.toasterService.showWarning('Please fill required fields');
      return;
    }
    console.log('form data',this.getFormData());

    this.backendApiService.postApi('products/create', this.getFormData())
      .subscribe((response: any)=>{
        console.log('response',response);
        this.toasterService.showSuccessMessage(response.data.message);
        this.close(response.data.data);
      })


  }

  touchFormControls(formName: any = this.proposalScopeProductForm){
    Object.keys(formName.controls).forEach(key => {
      this.proposalScopeProductForm.get(key)?.markAsTouched();
    });
  }
  removeHttp(){
    const url = this.helperService.removeHttp(this.proposalScopeProductForm.get('productUrl')?.value);
    this.proposalScopeProductForm.get('productUrl')?.setValue(url);
  }

  onClickMoveNext(formName:any) {
    if(formName.invalid) {
      this.touchFormControls(formName);
      this.toasterService.showErrorMessage('Please fill all the required fields');
      return;
    }
    this.stepper.next();
  }

  close = (data: any = null) => {
    this.dialogRef.close(data);
  }

  onItemSelect(event: any) {

  }

  onConfirmation(event: any) {

  }
  hideVendorSearch(event: any) {
    if(event.checked == true) {
      this.isVendor = true;
    } else {
      this.isVendor = false;
    }
  }

  createOrSelecteVendor(event: any) {
    const isVendor = this.proposalScopeProductForm.get('is_vendor')?.value;
    if(isVendor == true) {

      const manufacturer = this.proposalScopeProductForm.get('manufacturer')?.value;
      if(manufacturer) {

        this.vendorDataService.getByName(manufacturer?.name)
        .subscribe((result:any) => {
          const data =  result.data;
          console.log('vendorDataService', data);
          const vendor = data.vendor;
          console.log('vendorDataService vendor', vendor);
          if(vendor) {
            this.proposalScopeProductForm.get('vendor')?.setValue(vendor);
          } else {
            this.createQuickVendor(manufacturer?.name);
          }
  

        })

       

      } else {
        this.toasterService.showErrorMessage('Please select manufacturer');
        this.proposalScopeProductForm.get('is_vendor')?.setValue(false);
      }

    }
  }

  getVendorByName(name: any) {
    const vendor = this.vendors.find((x: any) => x.name == name);
    console.log('vendor',vendor);
    if(vendor) {
      this.proposalScopeProductForm.get('profit_markup')?.setValue(vendor?.markup ?? this.productDefaultMarkup);
      return {id: vendor?.id, name:vendor?.name}
    }
    return ;
  }

  createQuickVendor(data: any) {
    this.backendApiService.postApi('vendors/quick-create', {name:data,email:`${data}@gmail.com`})
      .subscribe((response: any) => {
        console.log('resposneee',response?.data?.data);
        const vendor = {id: response.data?.data?.id, name: response?.data?.data?.name};
        this.vendors.push(vendor);
        this.proposalScopeProductForm.get('vendor')?.setValue(vendor);
      })
  }

  setVendorOnchange(event: any) {
    const isVendor = this.proposalScopeProductForm.get('is_vendor')?.value;
    if(isVendor == true) {
      this.createOrSelecteVendor({cheked: true});
      const manufacturer = this.proposalScopeProductForm.get('manufacturer')?.value;
      // if(manufacturer) {
      //   const vendor = this.getVendorByName(manufacturer?.name);
      //   if (vendor) {
      //     this.proposalScopeProductForm.get('vendor')?.setValue(vendor);
      //   } else {
      //     this.createQuickVendor(manufacturer?.name);
      //   }
      // }
    }
  }

  setMarkup(event: any) {
    console.log('evenr',event);
    this.proposalScopeProductForm.get('vendor')?.setValue(event);
    this.proposalScopeProductForm.get('profit_markup')?.setValue(event?.markup ?? this.productDefaultMarkup);
  }

  getProductDefaultMarkup() {
    this.backendApiService.getApi('product-setting')
      .subscribe((response: any) => {
        if(response?.data?.status){
          // Backend now returns `preferred_markup` (lowercase p). Fall back to `default_markup` for backward compatibility.
          this.productDefaultMarkup = response.data?.preferred_markup ?? response.data?.default_markup;
          this.proposalScopeProductForm.get('profit_markup')?.setValue(this.productDefaultMarkup);
        }
      })
  }

  protected readonly CurrencyMaskOptions = CurrencyMaskOptions;
}
